import {EventEmitter, Injectable, Output} from '@angular/core';
import {ConfService} from './conf.service';
import {LeftpanelComponent} from './leftpanel/leftpanel.component';

@Injectable({
  providedIn: 'root'
})
export class DeploymentplanListenerService {

  @Output() deploymentPlanListener: EventEmitter<any> = new EventEmitter();


  constructor() {
    this.deploymentPlanListener.subscribe(
        (eventObject) => {
          // This listener has to be removed
        }
    );
  }
}
